<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet v-show="!currentItemMode" class="transparent-background-color">
      <v-card class="page-card">
        <v-row no-gutters class="ms-3">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("CRUD.viewInfo", [$consts.shopName()]) }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Shop.viewShopAddress", [$consts.shopName()]) }}
                </v-card-title>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-container>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("userInfo.shop_code") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ shopUser.shop ? shopUser.shop.shop_code : '' }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("userInfo.shop_name") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ shopUser.shop ? shopUser.shop.shop_name : '' }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("userInfo.user_name") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ shopUser.name }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("userInfo.login_id") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ shopUser.login_user_id }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" :class="
                savable
                ? 'font-weight-bold text-right mt-8'
                : 'font-weight-bold text-right'"
                  >
                    {{$t("userInfo.shop_address") + $t("Global.colon")}}
                  </v-col>
                  <v-col cols="9" md="7">
                    <!-- 三级地址 -->
                    <AddressText :masterItem="shopUser.shop" :detailAddress="shopUser.shop ? shopUser.shop.address : ''"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="headers"
                :items="shopAddresses"
                :loading="loading"
                multi-sort
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>

                <template v-slot:item.province="{ item }">
                  {{ citiesMap ? citiesMap[item.province] : "" }}
                </template>
                <template v-slot:item.city="{ item }">
                  {{ citiesMap ? citiesMap[item.city] : "" }}
                </template>
                <template v-slot:item.area="{ item }">
                  {{ citiesMap ? citiesMap[item.area] : "" }}
                </template>
                <template v-slot:item.default_flg="{ item }">
                  <div class="d-flex mt-n2 mb-n3">
                    <v-checkbox
                      v-model="item.default_flg"
                      :true-value="1"
                      :false-value="0"
                      :disabled="item.default_flg == 1 || !shopAddressEdit"
                      @click.stop="changeDefaultAddress(item)"
                    ></v-checkbox>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip
                    top
                    v-if="shopAddressEdit"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          currentItem = Object.assign({}, item, {
                            province_id: item.province,
                            city_id: item.city,
                            area_id: item.area,
                            org_default_flg: item.default_flg,
                          });
                          editDialog = true;
                        "
                      >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>{{$t("CRUD.editInfo", [$t("Shop.shopAddress")])}}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.default_flg &&
                      shopAddressEdit
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          currentItem = item;
                          deleteDialog = true;
                        "
                      >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>{{$t("CRUD.deleteInfo", [$t("Shop.shopAddress"),])}}</span>
                  </v-tooltip>
                </template>

                <template v-slot:body.append>
                  <tr>
                    <td colspan="8">
                      <v-btn
                        v-if="shopAddressEdit"
                        small
                        color="primary"
                        @click.stop="
                          currentItem = { id: 0, shop_id: accountUser ? userType == 0 ? accountUser.id : accountUser.shop_id : 0 };
                          editDialog = true;
                        "
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-plus</v-icon>
                        {{$t("CRUD.newInfo", [$t("Shop.shopAddress")])}}
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  block
                  outlined
                  color="primary"
                  class="elevation-1"
                  @click.stop="
                    currentItemMode = 'editPassword';
                  "
                >
                  {{ $t("userInfo.edit.password") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    </v-slide-x-transition>
    <EditDetail
      v-show="currentItemMode"
      :mode="currentItemMode"
      :shopUser="shopUser"
      v-on:mode="currentItemMode = $event"
    />

    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t("Shop.shopAddress")}}</span>

          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
              >fa-times
              </v-icon>
            </template>
            <span>
              {{$t("CRUD.backToList", [$t("Shop.shopAddress")])}}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="addressObserver">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <!-- 三级地址 -->
                    <CitiesSelectGroup
                      :masterItem="currentItem"
                      @provinceSelected="
                        currentItem.province = currentItem.province_id =
                          $event.id
                      "
                            @citySelected="
                        currentItem.city = currentItem.city_id = $event.id
                      "
                            @districtSelected="
                        currentItem.area = currentItem.area_id = $event.id
                      "
                    />
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_receiving_address')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentItem.address"
                        :label="$t('Shop.Fields.shop_receiving_address')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'address')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_address_name')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentItem.name"
                        :label="$t('Shop.Fields.shop_address_name')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_tel')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentItem.phone"
                        :label="$t('Shop.Fields.shop_user_tel')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'phone')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <div class="d-flex mt-n3 mb-n3">
                      <v-checkbox
                        v-model="currentItem.default_flg"
                        :label="$t('Shop.Fields.shop_default_address')"
                        :true-value="1"
                        :false-value="0"
                        :disabled="currentItem.org_default_flg == 1"
                      ></v-checkbox>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{$t("$vuetify.close")}}</v-btn>
          <v-btn color="accent" @click="saveShopAddress()">{{$t("CRUD.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogAlert
      v-model="settingDefaultAddressDialog"
      :message="settingDefaultAddressMsg"
      useConfirm
      @close="
        settingDefaultAddressDetail.default_flg =
          settingDefaultAddressDetail.default_flg ? 0 : 1
      "
      @confirm="settingDefaultAddress()"
    />

    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Shop.shopAddress')"
      @confirm="
        deleteShopAddress();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddressText from "@/components/plugins/AddressText";
import DialogAlert from "@/components/plugins/DialogAlert";
import DialogDelete from "@/components/plugins/DialogDelete";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import ShopUsers from "@/api/shop_users";
import ShopAddress from "@/api/shop_address";
import Settings from "@/api/settings";
import EditDetail from "./plugins/Detail";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Breadcrumbs,
    AddressText,
    EditDetail,
    DialogAlert,
    DialogDelete,
    CitiesSelectGroup,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.userInfo"),
        disabled: true,
        href: "/user",
      },
    ],
    headers() {
      let headers = [
        {
          text: i18n.t("Area.city_1"),
          align: "start",
          sortable: true,
          value: "province",
        },
        {
          text: i18n.t("Area.city_2"),
          align: "start",
          sortable: true,
          value: "city",
        },
        {
          text: i18n.t("Area.city_3"),
          align: "start",
          sortable: true,
          value: "area",
        },
        {
          text: i18n.t("Shop.Fields.shop_receiving_address"),
          align: "start",
          sortable: true,
          value: "address",
        },
        {
          text: i18n.t("Shop.Fields.shop_address_name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: i18n.t("Shop.Fields.shop_user_tel"),
          align: "start",
          sortable: true,
          value: "phone",
        },
        {
          text: i18n.t("Shop.Fields.shop_default_address"),
          align: "start",
          sortable: true,
          value: "default_flg",
        },
      ]
      if (this.shopAddressEdit) {
        headers.push(
          {
            text: i18n.t("TableHeaders.actions"),
            align: "start",
            class: "text-no-wrap",
            sortable: false,
            value: "actions",
          },
        )
      }
      return headers
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "citiesMap", "accountUser", "userType"]),
  },


  data: () => ({
    tab: null,
    savable: false,
    shopUser: {},
    serverErrors: [],
    currentItemMode: "",
    currentItem: {},
    shopAddresses: [],
    shopAddressEdit: false,
    editDialog: false,
    deleteDialog: false,
    addressServerErrors: [],
    settingDefaultAddressDialog: false,
    settingDefaultAddressMsg: "",
    settingDefaultAddressDetail: null,
  }),

  mounted() {
    this.getUserInfo()
    this.getShopAddressFromAPI()
  },

  methods: {
    getUserInfo() {
      ShopUsers.getUserInfo().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopUser = response.data.shopUser
          }
        }.bind(this)
      )
    },
    getShopAddressFromAPI() {
      ShopAddress.fetchByShop().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopAddresses = response.data.shop_address;
            Settings.getSettings({keys:["shop_address_edit"]}).then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (response.data.settings.shop_address_edit) {
                    this.shopAddressEdit = true
                  }
                }
              }.bind(this)
            )
          }
        }.bind(this)
      );
    },
    changeDefaultAddress(item) {
      if (item.default_flg) {
        this.settingDefaultAddressDetail = item;
        this.settingDefaultAddressMsg = i18n.t(
                "Shop.settingDefaultShopAddress",
                [item.address]
        );
        this.settingDefaultAddressDialog = item.default_flg == 1;
      }
    },
    settingDefaultAddress() {
      if (this.settingDefaultAddressDetail) {
        this.settingDefaultAddressDetail.default_flg = 1;
        ShopAddress.save(
          this.settingDefaultAddressDetail.id, this.settingDefaultAddressDetail
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopAddressFromAPI();
            }
          }.bind(this)
        );
      }
    },
    saveShopAddress() {
      if (this.currentItem) {
        this.$store.dispatch("fullscreenLoading");
        this.$refs.addressObserver.validate().then(
          function (result) {
            if (result) {
              ShopAddress.save(this.currentItem.id, this.currentItem).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.getShopAddressFromAPI();
                    this.$refs.addressObserver.reset();
                    this.editDialog = false;
                  } else if (
                          response.data.error &&
                          response.data.error.data &&
                          response.data.error.code == "ERR333"
                  ) {
                    this.addressServerErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    deleteShopAddress() {
      if (this.currentItem && this.currentItem.id) {
        ShopAddress.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopAddressFromAPI();
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    currentItemMode: {
      handler() {
        if (!this.currentItemMode) {
          this.getUserInfo()
        }
      }
    },
    currentItem: {
      handler() {
        console.log('currentItem', this.currentItem)
      }
    }
  },
};
</script>